import { Reveal } from "@/components/Reveal";
import VitrineCarousel from "@/components/VitrineCarousel";
import { IMAGES } from "@/lib/sections";

const COLS = [
  {
    n: "I",
    title: "Gold Foil Art",
    body: "Sacred wall art and devotional gifting collections crafted in certified 24KT gold foil.",
    srcs: IMAGES.worldGoldFoil,
    mode: "bleed",
  },
  {
    n: "II",
    title: "Gold Plated Sculptures",
    body: "Modern spiritual décor and collectible gifting objects inspired by Indian symbolism.",
    srcs: IMAGES.worldSculpture,
    mode: "clean",
    cleanOptions: { threshold: 230, soft: 28 },
  },
  {
    n: "III",
    title: "VViola Glassware",
    body: "Luxury gold-accented glassware and barware for modern homes and celebrations.",
    srcs: IMAGES.worldGlassware,
    mode: "bleed",
  },
];

export default function World() {
  return (
    <section
      id="world"
      data-testid="section-world"
      className="deck-section relative bg-ink"
    >
      <div className="mx-auto w-full max-w-[1600px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <Reveal className="lg:col-span-7">
            <div className="num-overline">04 · The World</div>
            <h2 className="mt-8 font-heading text-ivory text-4xl md:text-5xl lg:text-[64px] leading-[1.05] tracking-tightest">
              The Aarya24KT <span className="italic text-gold">world.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-5">
            <p className="font-body text-beige/75 text-[15px] leading-[1.85] max-w-md">
              Three signature universes — each a complete language of luxury for
              the modern Indian home and the global retailer.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {COLS.map((c, i) => (
            <div key={i} className="group">
              <VitrineCarousel
                images={c.srcs}
                alt={c.title}
                mode={c.mode}
                aspect="aspect-[3/4]"
                delay={0.15 + i * 0.1}
                cleanOptions={c.cleanOptions}
              />
              <Reveal delay={0.25 + i * 0.1}>
                <div className="mt-6 flex items-baseline gap-4">
                  <span className="font-heading italic text-gold text-lg">
                    {c.n}
                  </span>
                  <div className="h-px flex-1 bg-gold/20" />
                </div>
                <h3 className="mt-4 font-heading text-ivory text-2xl md:text-3xl">
                  {c.title}
                </h3>
                <p className="mt-3 font-body text-[14px] leading-[1.75] text-beige/70 max-w-xs">
                  {c.body}
                </p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
